module.exports = __webpack_public_path__ + "static/media/submarine.78d88251.jpg";